












import { UiTooltip } from './keen-ui';

export default {
  name: 'epb-badge',
  components: {
    UiTooltip
  },
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    color: {
      type: String,
      default: 'primary'
    },
    tooltip: String,
    tooltipPosition: {
      type: String,
      default: 'bottom left'
    }

  },
  data: function () {
    return {
      baseClass: 'epb-badge'
    };
  }
};
